import { useEffect, useState } from "react";

/* Les grands chantiers ouverts sur CE serveur (version de test d'abord, puis en prod une
   fois validés par l'école) : { horaires_partages: true, spectacles_juin: false, … }.
   Lu une seule fois par visite (/api/environnement), partagé par tous les écrans. */
let promesse = null;
const lire = () => {
  if (!promesse) {
    promesse = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/environnement`)
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => ({ site: d.chantiers || {}, console: d.console || d.chantiers || {} }))
      .catch(() => ({ site: {}, console: {} }));
  }
  return promesse;
};

/* useChantiers() : ce que voient le site et les apps. useChantiers("console") : les écrans
   de la console, qui peuvent s'ouvrir en production avant le reste (les spectacles de juin,
   Jen 03.11.2026 : la console oui, la billetterie du site attend Payrexx). */
export function useChantiers(ou = "site") {
  const [chantiers, setChantiers] = useState({});
  useEffect(() => {
    let vivant = true;
    lire().then((c) => { if (vivant) setChantiers(c[ou] || {}); });
    return () => { vivant = false; };
  }, [ou]);
  return chantiers;
}
